import React, { useState, useRef } from 'react';

import ReCAPTCHA from 'react-google-recaptcha';
import { Modal, Form, Button } from 'react-bootstrap';
import SuccessImg from '../../../../assets/images/success.svg';
import { contactUs } from '../../../../api';
import './feedback_form.component.css';

const FeedbackForm = (props) => {
  const [isModalFormVisible, setIsModalFormVisible] = useState(true);
  // feedback form
  const formRef = useRef(null);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const invisibleCaptchaRef = useRef(null);

  const submitForm = async (e) => {
    setIsError(false);
    e.preventDefault();
    formRef.current.reportValidity();
    if (formRef.current.checkValidity()) {
      invisibleCaptchaRef.current.reset();
      try {
        const token = await invisibleCaptchaRef.current.executeAsync();
        const payload = {
          sender_name: name,
          sender_address: email,
          message,
          captcha_response: token,
          captcha_type: 'invisible',
        };
        const res = await contactUs(payload);
        setIsModalFormVisible(false);
      } catch (error) {
        setIsError(true);
      }
    }
  };

  return (
    <Modal
      show={props.show}
      centered
      onHide={() => props.setShow(false)}
      className="fb-modal"
    >
      <Modal.Body
        className={`fb-modal-body ${!isModalFormVisible ? 'd-none' : ''}`}
      >
        <div className="fb-form-head">
          <div>LEAVE FEEDBACK</div>
          <div>We'd love to hear from you!</div>
        </div>
        <Form ref={formRef}>
          <Form.Group controlId="name">
            <Form.Label>NAME</Form.Label>
            <Form.Control
              type="text"
              required
              onChange={(e) => setName(e.target.value)}
              value={name}
            ></Form.Control>
          </Form.Group>
          <Form.Group controlId="email">
            <Form.Label>EMAIL</Form.Label>
            <Form.Control
              type="email"
              required
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            ></Form.Control>
          </Form.Group>
          <Form.Group controlId="message">
            <Form.Label>MESSAGE</Form.Label>
            <Form.Control
              as="textarea"
              required
              onChange={(e) => setMessage(e.target.value)}
              value={message}
            ></Form.Control>
          </Form.Group>
          {isError && (
            <p className="text-danger mb-0">
              Something went wrong. Please try again later.
            </p>
          )}
          <ReCAPTCHA
            ref={invisibleCaptchaRef}
            size="invisible"
            sitekey={process.env.GOOGLE_INVISIBLE_RECAPTCHA_KEY}
          ></ReCAPTCHA>
          <Button type="submit" className="fb-submit-btn" onClick={submitForm}>
            SUBMIT
          </Button>
        </Form>
      </Modal.Body>
      <Modal.Body
        className={`fb-modal-body-cls ${isModalFormVisible ? 'd-none' : ''}`}
      >
        <div className="text-center">
          <img src={SuccessImg} width="100" />
          <div>
            Thank you! Someone from our team will get in touch with you shortly.
          </div>
        </div>
        <Button
          type="button"
          onClick={() => props.setShow(false)}
          className="fb-modal-cls-btn"
        >
          Close
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default FeedbackForm;
